/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import cn from 'classnames'
import classes from '../../style/index.styl'
import { download } from '../../util/download'
import { ToolbarPageInput, ToolbarPageInputProps } from './page-input'
import { ToolbarZoomInput, ToolbarZoomInputProps, } from './zoom-input'


export interface ToolbarProps
  extends ToolbarPageInputProps, ToolbarZoomInputProps {
  /**
   * pdf 文件 url
   */
  fileUrl: string
  /**
   * pdf 文件名称
   */
  fileName: string
}


export function Toolbar(props: ToolbarProps): React.ReactElement {
  const { fileUrl, fileName } = props
  const handleDownload = () => {
    download(fileUrl, fileName)
  }

  return (
    <div className={ classes.toolbar }>
      <div className={ classes.toolbarContainer }>
        <div className={ classes.toolbarViewer }>
          <ToolbarPageInput
            className={ classes.toolbarViewerLeft }
            pageNumber={ props.pageNumber }
            pageTotal={ props.pageTotal }
            onPageNumberChange={ props.onPageNumberChange }
          />
          <ToolbarZoomInput
            className={ classes.toolbarViewerMiddle }
            scale={ props.scale }
            MIN_SCALING={ props.MIN_SCALING }
            MAX_SCALING={ props.MAX_SCALING }
            ZOOM_STEP={ props.ZOOM_STEP }
            scaleOptions={ props.scaleOptions }
            onScaleChange={ props.onScaleChange }
          />
          <div className={ classes.toolbarViewerRight }>
            <button
              title="下载"
              tabIndex={ 34 }
              data-l10n-id="download"
              className={ cn(classes.download, classes.toolbarButton /***, classes.hiddenMediumView */) }
              onClick={ handleDownload }
            >
              <span data-l10n-id="download_label">下载</span>
            </button>
          </div>
        </div>
        <div className={ classes.loadingBar }>
          <div className={ classes.progress }>
            <div className={ classes.glimmer } />
          </div>
        </div>
      </div>
    </div>
  )
}


export default Toolbar
